(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.stav-pdp-redesign fieldset').forEach((fieldset) => {
      if (fieldset.dataset.stavLabelsReady || !fieldset.querySelector('[data-stav-option-label]')) return;
      fieldset.dataset.stavLabelsReady = 'true';
      const update = () => {
        const selected = fieldset.querySelector('input[data-stav-option-label]:checked');
        if (!selected) return;
        fieldset.querySelectorAll('.option_value').forEach((label) => {
          if (label.textContent !== selected.dataset.stavOptionLabel) {
            label.textContent = selected.dataset.stavOptionLabel;
          }
        });
        const factMaterial = selected.dataset.stavFactMaterial;
        if (factMaterial && fieldset.classList.contains('product-form__input_color')) {
          const product = fieldset.closest('.stav-pdp-redesign');
          const material = product?.querySelector('[data-product-fact-material]');
          if (material && material.textContent.trim() !== factMaterial) {
            material.textContent = factMaterial;
          }
        }
      };
      fieldset.addEventListener('change', update);
      new MutationObserver(update).observe(fieldset, { childList: true, subtree: true, characterData: true });
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
